import { useEffect, useState } from "react";
import { Dialog } from "../components/Dialog";
import { Avatar } from "../components/Avatar";
import { useAuth } from "../security/AuthContext";
import { AvatarButton } from "../components/AvatarButton";
import { useNotification } from "../components/Notifications";
import { Tooltip } from "../components/Tooltip";
import { Tab, TabsComponent } from "../components/Tabs";


export function Test() {
  const { user } = useAuth();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { addNotification } = useNotification();

  const handleOpen = () => {
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  const showInfo = (msg) => {
    addNotification(msg);
  };

  const showError = (msg) => {
    addNotification(msg, 'error');
  };


  return (
    <>
      <TabsComponent>
        <Tab id="profile" label="Profile" icon="fa-user">
          This is the Profile tab content. Add your user information here.
        </Tab>
        <Tab id="dashboard" label="Dashboard" icon="fa-chart-bar">
          This is the Dashboard tab content. Display your charts and stats here.
        </Tab>
        <Tab id="settings" label="Settings" icon="fa-cog">
          This is the Settings tab content. Configure your preferences here.
        </Tab>
      </TabsComponent> 

      <Avatar user={user} />
      <AvatarButton user={{id:2,firstName:'John',lastName:'Pecci'}} handleClick={() => showInfo('Hello from Avatar')} big={false}/>
      <AvatarButton user={{id:2,firstName:'John',lastName:'Pecci'}} handleClick={() => showError('I am big')} big={true}/>
      <div className="relative group">
        <button
          className="px-6 py-3 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          onClick={handleOpen}
        >
          <i className="fas fa-window-restore mr-2"></i>Open Dialog
        </button>
      <Tooltip text={"This Is Modal"}></Tooltip>
      </div>
      <Dialog
        isOpen={isDialogOpen}
        onClose={handleClose}
        title="Programmatic Dialog"
      >
        <p className="text-gray-600">
          This dialog is built as a reusable React component with Tailwind CSS and Font Awesome icons. It opens programmatically after 2 seconds or via the button.
        </p>
      </Dialog>
    </>
  );

}